/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sla_Region_Without_CarrierInputs */

const vi_error_sla_region_without_carrier = /** @type {(inputs: Error_Sla_Region_Without_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ dòng gắn nhà vận chuyển mới chọn được miền. Vui lòng chọn nhà vận chuyển hoặc bỏ chọn miền.`)
};

/**

* @param {Error_Sla_Region_Without_CarrierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_sla_region_without_carrier = /** @type {((inputs?: Error_Sla_Region_Without_CarrierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sla_Region_Without_CarrierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_sla_region_without_carrier(inputs)
});